import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiConfig} from '../../../shared/services/api/config.api';
import {HttpClient, HttpHeaders} from '@angular/common/http';


@Injectable()
export class PensionCalculatorService {

  constructor(public httpClient: HttpClient) {

  }
  calculatePension(body: Object): Observable<any> {
    // let bodyString = JSON.stringify(body); // Stringify payload
    const requestOptionsHeader = new HttpHeaders();
    requestOptionsHeader.set('Content-Type', 'application/json;charset=UTF-8')
    requestOptionsHeader.set('Accept', 'application/json;charset=UTF-8')

    return this.httpClient.post(ApiConfig.baseURL + 'api/calculator/calculate', body, {headers: requestOptionsHeader})
  }
}
